<template>
  <div>
    <div class="floating">
      <router-link to="/" exact >
        <span>
          <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-zhuye"></use>
        </svg>
        </span>
      </router-link>
      <router-link to>
        <span>
          <svg class="icon" aria-hidden="true" @click="$router.back(-1)">
          <use xlink:href="#icon-return"></use>
        </svg>
        </span>
      </router-link>
    </div>

  </div>
</template>

<script>
    export default {
        name: 'floating'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/floating.vue